import React from 'react';
import { Trophy } from 'lucide-react';

/**
 * WonPill — the tenant-wide badge for "this call/deal was won".
 * A single visual so every surface (Calls list, Revivable rows, Call
 * detail, Related-calls card, Digest) reads identically.
 *
 * Props:
 *   source: 'auto' | 'user' | 'manager' — flavours the tooltip so leaders
 *           can tell whether the AI classified it or a human flipped it.
 *   by:     email/name of the actor (only shown on hover).
 *   size:   'xs' (default) | 'sm' — controls padding/text size.
 */
const WonPill = ({ source, by, size = 'xs', className = '', ...rest }) => {
  const label = source === 'auto' ? 'AI detected'
    : source === 'manager' ? `Marked by manager${by ? ` · ${by}` : ''}`
    : source === 'user' ? `Marked by agent${by ? ` · ${by}` : ''}`
    : (by ? `Won · ${by}` : 'Won');

  const cls = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-[10px] px-1.5 py-[1px]';

  return (
    <span
      className={`inline-flex items-center gap-1 font-bold rounded-full bg-emerald-100 text-emerald-800 border border-emerald-200 ${cls} ${className}`}
      title={label}
      data-testid="won-pill"
      {...rest}
    >
      <Trophy className={size === 'sm' ? 'w-3 h-3' : 'w-2.5 h-2.5'} />
      WON
    </span>
  );
};

export default WonPill;
